import React, { useState } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { useTranslation } from "react-i18next";

const ITEMS_THRESHOLD = 5;

function CollapsibleValues({ values }) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  if (!_.isArray(values) || values.length <= ITEMS_THRESHOLD) {
    return <span>{_.isArray(values) ? values.join(", ") : values}</span>;
  }

  const toggleLabelStyle = {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    color: "#a0a1df",
    fontSize: "0.8em",
    fontWeight: "bold",
    marginLeft: 0,
  };

  return (
    <span>
      {expanded
        ? <span>{values.join(", ")} </span>
        : <span>{t("groupSettings.itemsSelected", { count: values.length })} </span>
      }
      <button style={toggleLabelStyle} onClick={() => setExpanded(prev => !prev)}>
        {expanded ? t("groupSettings.verMenos") : t("groupSettings.verMas")}
      </button>
    </span>
  );
}

CollapsibleValues.propTypes = {
  values: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};

export default CollapsibleValues;
